// extracted by mini-css-extract-plugin
export default {"container":"game_container__tvg+i"};